// Mock implementation of Next.js font functions
export const Roboto = (options: any) => ({
  className: 'roboto-font',
  style: { fontFamily: 'Roboto, sans-serif' }
});

export const Poppins = (options: any) => ({
  className: 'poppins-font',
  style: { fontFamily: 'Poppins, sans-serif' }
}); 